import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})

export class AutoDocumentTypeService {
  constructor(public apiService: ApiService) { }

  fetch(data: any): Promise<any> {
    return this.apiService.fetch('/common/auto-complete/document-type', data);
  }
}
